import React from 'react'
import {useLocation, Link} from "react-router-dom";

import "./Breadcrumbs.css";
import {convertSlugToTitle} from "../../utils/getReadableSlugs";

const Breadcrumbs = () => {
    const [pathStack, setPathStack] = React.useState([])
    const location = useLocation()
    const pathname = location.pathname.split('/').filter(x => x);

    if (pathname.length === 0) {
        return <nav>
            <ol>
                <li>
                    <Link to="/">Home</Link>
                </li>
            </ol>
        </nav>
    }

    if (pathStack.includes(pathname[pathname.length-1])) {
        while (pathStack[pathStack.length-1] !== pathname[pathname.length-1]) {
            setPathStack([...pathStack-1]);
        }
    } else if (
        pathStack.length === pathname.length - 1 &&
        pathStack.every((val, index) => val === pathname[index])
    ) {
        setPathStack([...pathStack, pathname[pathname.length-1]]);
    } else {
        setPathStack(pathname);
    }

    return (
        <nav>
            <ol>
                <li>
                    <Link to="/">Home</Link>
                </li>

                {pathStack.map((value, index) => {
                    const last = index === pathStack.length - 1
                    let to = `/${pathStack.slice(0, index + 1).join('/')}`
                    if (to === "/database") {
                        to = `/databases/`
                    } else if (to.endsWith("/filter")) {
                        to = to.replace("/filter", "/")
                    } else if (to === "/user") {
                        to = `/users/`
                    } else if (to === "/role") {
                        to = `/roles/`
                    } else if (to === "/organization_user") {
                        to = `/organization_users/`
                    }

                    return (
                        <li key={to}>
                            <span className="link-separator">/</span>
                            {last ? (
                                <span>{convertSlugToTitle(pathStack[index], pathStack[index-1])}</span>
                            ) : (
                                <Link to={to}>{convertSlugToTitle(pathStack[index])}</Link>
                            )}
                        </li>
                    );
                })}
           </ol>
        </nav>
    );
};

export default Breadcrumbs
